export const TOGGLE_DAILY_CARD_SUMMARY_DETAILS = 'TOGGLE_DAILY_CARD_SUMMARY_DETAILS';

export type ToggleExpandDailySummaryDetailsActionType = {
    type: typeof TOGGLE_DAILY_CARD_SUMMARY_DETAILS;
    payload: number;
}

export function toggleExpandDailySummaryDetails(selectedDayCardIndex: number): ToggleExpandDailySummaryDetailsActionType {
    return {
        type: TOGGLE_DAILY_CARD_SUMMARY_DETAILS,
        payload: selectedDayCardIndex
    };
}